// removed by extract-text-webpack-plugin
module.exports = {"Tabs":"Tabs__Tabs___23ukX","Tab":"Tabs__Tab___2jQhl","TabText":"Tabs__TabText___1zQyL"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResumeBox/Tabs/Tabs.css
// module id = 33
// module chunks = 0